import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable, of, shareReplay } from "rxjs";
import { PaginationDocuments, IDigitalSignatureDocument, ICreateDigitalSignatureDocument, IResponseDigitalSignatureDocument, IGetDocumentsFilterModel, RemoveDocumentRequest } from "../models/digital-sinagture.models";
import { environment } from "src/environments/environment";
import { stripNullishParams } from "../helpers/utils/http-params.util";

@Injectable({
  providedIn: "root",
})

export class DigitalSignatureService {
  private endpoint = `${environment.url}/v1/digital-signature`;

  constructor(private http: HttpClient) { }

  // getById(id: number): Observable<IDigitalSignatureDocument> {
  //   return this.http.get<IDigitalSignatureDocument>(`${this.endpoint}/${id}`);
  // }

  getById(id: number): Observable<IDigitalSignatureDocument> {
    return this.http.get<IDigitalSignatureDocument>(`${this.endpoint}/${id}`)
      .pipe(
        map((doc) => {
          if (doc.deletedEmployeeImage) {
            doc.deletedEmployeeImage = `data:image/png;base64,${doc.deletedEmployeeImage}`;
          }
          return doc;
        })
      );
  }


  getSignedDocumentUrl(documentId: number): Observable<any> {
    return this.http.get(`${this.endpoint}/${documentId}/download_url`,
      { responseType: 'text' });
  }


  // getSignedDocumentUrl(documentId: number): Observable<string>  {
  //   return this.http.get<string>(`${this.endpoint}/${documentId}/download_url`)
  //     .pipe(
  //       map((doc) => {
  //         if (doc.deletedEmployeeImage) {
  //           doc.deletedEmployeeImage = `data:image/png;base64,${doc.deletedEmployeeImage}`;
  //         }
  //         return doc;
  //       })
  //     );
  // }


  /*get(model: IGetDocumentsFilterModel): Observable<PaginationDocuments<IDigitalSignatureDocument>> {
     return this.http.get<IResponseDigitalSignatureDocument>(`${this.endpoint}`, { params: { ...model } })
       .pipe(map(response => response.data));
   }*/


  get(model: IGetDocumentsFilterModel): Observable<PaginationDocuments<IDigitalSignatureDocument>> {
    return this.http.get<IResponseDigitalSignatureDocument>(`${this.endpoint}`, { params: stripNullishParams({ ...model }) })
      .pipe(
        map(response => {
          const data = response.data;

          data.content = data.content.map((doc) => {

            if (doc.employeeImage) {
              doc.employeeImage = `data:image/png;base64,${doc.employeeImage}`;
            }

            if (doc.deletedEmployeeImage) {
              doc.deletedEmployeeImage = `data:image/png;base64,${doc.deletedEmployeeImage}`;
            }
            return doc;
          });

          return data;
        })
      );
  }


  /*delete(documentId: number): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${documentId}`);
  }*/

  delete(documentId: number, model: RemoveDocumentRequest): Observable<void> {
    return this.http.patch<void>(`${this.endpoint}/${documentId}/delete`, model);
  }

  // deleteAll(documentIds:number[], model: RemoveDocumentRequest[]) : Observable<void> {
  //   return this.http.patch<void>(`${this.endpoint}/${documentIds}/deleteAll`, model);
  // }


  deleteAll(listId: number[], observation: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: { ListId: listId, Observation: observation }
    };
    return this.http.delete(`${this.endpoint}/delete_all`, options).pipe(shareReplay());
  }

  create(model: ICreateDigitalSignatureDocument): Observable<void> {
    return this.http.post<void>(`${this.endpoint}`, model);
  }

  update(id: number, document: ICreateDigitalSignatureDocument): Observable<void> {
    return this.http.put<void>(`${this.endpoint}/${id}`, document);
  }

  getDigitalSignatureDocumentType = () =>
    this.http.get(`${this.endpoint}/document-type`);


}
